export class DateFormatConstants {
}
DateFormatConstants.DATE_FORMAT_MM_DD_YYYY = 'MM/DD/YYYY';
DateFormatConstants.DATE_FORMAT_M_D_YYYY = 'M/D/YYYY';
DateFormatConstants.DATE_FORMAT_YYYY_MM_DD_HH_MM_SS = 'YYYY-MM-DD HH:mm:ss';
DateFormatConstants.DATE_FORMAT_DDD_D_MMM = 'ddd, D MMM';
DateFormatConstants.DATE_FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
DateFormatConstants.DATE_FORMAT_YYYYMMDD = 'YYYYMMDD';
DateFormatConstants.DATE_FORMAT_M_D_YY = 'M/D/YY';
DateFormatConstants.DATE_FORMAT_YY_M_D = 'YY-M-D';
DateFormatConstants.DATE_FORMAT_D_M_YY = 'D/M/YY';
// date formate 07/11/2021 2:22 AM
DateFormatConstants.DATE_FORMAT_MM_DD_YYYY_HH_MM = 'MM/DD/YYYY hh:mm A';
DateFormatConstants.DATE_FORMAT_HH_MM = 'hh:mm A';
DateFormatConstants.DATE_FORMAT_M_DD_YY_H_M = 'M/DD/YY h:m A';
DateFormatConstants.DATE_FORMAT_YYYY_MM_DD = 'YYYY/MM/DD';
DateFormatConstants.DATE_FORMAT_M_D_YYYY_HH_MM_SS_A = 'M/D/YYYY, hh:mm:ss A';
DateFormatConstants.DATE_FORMAT_MM_DD_YY_HH_MM_A = 'MM/DD/YY hh:mm A';
DateFormatConstants.DATE_FORMAT_M_D_YY_HH_MM_A = 'M/D/YY hh:mm A';
DateFormatConstants.DATE_FORMAT_M_D_YY_H_MM_A = 'M/D/YY h:mm A';
DateFormatConstants.DATE_FORMAT_MMM_DD_YYYY = 'MMM DD, YYYY';
DateFormatConstants.DATE_FORMAT_MMM_DD_YYYY_HH_MM_A = 'MMMM DD, YYYY hh:mm A';
DateFormatConstants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS_A = 'MM/DD/YYYY HH:mm:ss A';
DateFormatConstants.DATE_FORMAT_YY_M_D_HH_MM = 'YY-M-D HH:mm';
DateFormatConstants.DATE_FORMAT_YYY_MM_DD_HH_MM_SS_A = 'YYYY-MM-DD hh:mm:ss A';
DateFormatConstants.DATE_FORMAT_YYYY_MM_DD_HH_MM_SS_SSS = 'YYYY-MM-DD HH:mm:ss:SSS';
DateFormatConstants.DATE_FORMAT_YYYY_MM_DD_HH_MM_A = 'YYYY-MM-DD hh:mm A';
DateFormatConstants.MM_DD_YYYY_NON_MILITARY_TIME_FORMAT = 'MM/DD/YYYY LT';
DateFormatConstants.DATE_TIME_FORMAT_FRENCH = 'YY-MM-DD HH:mm A';
DateFormatConstants.DATE_TIME_FORMAT_MMM_DD_HH_MM = 'MMM. DD, HH:mm';
DateFormatConstants.DATE_UPDATED_FORMAT_YYYY_MM_DD_HH_MM_A = 'YYYY-MM-DD, hh:mm:ss A'; // date formate 2021-07-11, 2:22:22 AM
DateFormatConstants.DATE_UPDATED_FORMAT_MM_DD_YYYY_HH_MM = 'MM/DD/YYYY, hh:mm:ss A'; // date formate 07/11/2021, 2:22:22 AM
//# sourceMappingURL=DateFormatConstants.js.map